import { connect } from 'react-redux'

import { getAgentProfile } from './agentProfile.actions'
import AgentProfileDialog, { UnstyledAgentProfileDialog } from './Dialog.component'

const mapStateToProps = ({ agentProfile: { agentProfile } }) => ({
  loading: agentProfile.loading,
  agent: agentProfile.data,
  error: agentProfile.error,
})

const mapDispatchToProps = (dispatch, { agentId }) => ({
  async onOpen(cancelToken) {
    try {
      const agentProfileResult = dispatch(getAgentProfile(agentId, cancelToken))
      await agentProfileResult
    // eslint-disable-next-line no-empty -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
    } catch (e) {}
  },
})

export { UnstyledAgentProfileDialog }

export default connect(mapStateToProps, mapDispatchToProps)(AgentProfileDialog)
